module.exports = "<p>\n  check works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/legal/check/check.component.html
// module id = ./src/app/legal/check/check.component.html
// module chunks = main